import getRedirect from '../utils/data/getRedirect'
import queryServerSideData from '../utils/data/queryServerSideData'
import PageError from '../components/PageError/PageError'
import getSession from '../utils/auth/getSession'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import getSiteHandle from '../utils/i18n/getSiteHandle'

const redirectFallback = () => {
  return (
    <>
      <PageError errorCode={404} />
    </>
  )
}

export default redirectFallback

const getFallbackUrl = (slug, entryId, typeHandle) => {
  if (
    (slug === 'exercise' && typeHandle === slug) ||
    (slug === 'training' && (typeHandle === slug || typeHandle === 'userTraining')) ||
    (slug === 'program' && (typeHandle === slug || typeHandle === 'userProgram'))
  ) {
    return `/${slug}/id/${entryId}`
  } else {
    return false
  }
}

export async function getServerSideProps({ params, req, res, locale }) {
  const session = await getSession(req, res)

  if (session.error) {
    return {
      props: {
        error: true,
        errorCode: session.status,
        message: session.message,
        ...(await serverSideTranslations(locale || process.env.NEXT_PUBLIC_RINUS_DEFAULT_LANGUAGE, process.env.NEXT_PUBLIC_RINUS_NAMESPACES?.split(',')))
      }
    }
  }

  // build up current URL
  const uri = params.slug.join('/')

  // check if url structure is /(exercise/training/program/[id]) and redirect to /typehandle/id/[id]
  if (uri.includes('program/') || uri.includes('training/') || uri.includes('exercise/')) {
    const entryId = parseInt(params.slug[1])
    if (!isNaN(entryId)) {
      const fallbackDetailJson = await queryServerSideData(
        'qFallbackDetail.graphql',
        { id: entryId },
        session.cookieString
      )
      const fallbackUrl = fallbackDetailJson?.data?.entry?.typeHandle
        ? getFallbackUrl(params.slug[0], entryId, fallbackDetailJson?.data?.entry?.typeHandle)
        : false
      if (fallbackUrl) {
        return {
          redirect: {
            destination: fallbackUrl,
            statusCode: 301
          }
        }
      }
    }
  }

  // Check if there is a redirection based on retour
  // validate if there is a redirection in place
  const redirectionData = await getRedirect(`/${uri}`)
  if (redirectionData && redirectionData.redirectHttpCode !== null) {
    return {
      redirect: {
        destination: redirectionData.redirectDestUrl,
        statusCode: redirectionData.redirectHttpCode
      }
    }
  }

  const siteHandle = getSiteHandle(locale)
  const globalJson = await queryServerSideData(
    'qGlobal.graphql',
    { site: siteHandle, seoUri: '/', seoSite: siteHandle },
    session.cookieString
  )

  return {
    props: {
      statusCode: 404,
      pageTitle: 'Pagina niet gevonden',
      ...(await serverSideTranslations(locale || process.env.NEXT_PUBLIC_RINUS_DEFAULT_LANGUAGE, process.env.NEXT_PUBLIC_RINUS_NAMESPACES?.split(','))),
      ...globalJson.data
    }
  }
}
